import { Component, input } from '@angular/core';
import { Observable } from 'rxjs';
import { ButtonStyles } from '../../../../button/button.component';
import { ZiroIcons } from '../../../../shared/models/ziro-icons.enum';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'ziro-saml-export-btn',
  templateUrl: './saml-export-button.component.html',
  standalone: false,
})
export class SamlExportButtonComponent {
  readonly event = input<() => Observable<void>>();
  readonly label = input('');
  readonly isDisabled = input(false);
  readonly dataAutomation = input('');
  readonly buttonStyle = input(ButtonStyles.OUTLINE_PRIMARY);
  readonly pendingStyle = input(ButtonStyles.OUTLINE_WARNING);
  readonly icon = input(ZiroIcons.EXPORT);
  readonly iconPending = input(ZiroIcons.SAVING);

  isPending = false;

  onButtonClick(): void {
    this.isPending = true;
    this.event()().subscribe({
      next: () => {
        this.isPending = false;
      },
      error: (error) => {
        this.isPending = false;
        throw new HttpErrorResponse(error);
      },
    });
  }
}
